import { render, staticRenderFns } from "./NhapKho.vue?vue&type=template&id=5ff5dce3&scoped=true&"
import script from "./NhapKho.vue?vue&type=script&lang=js&"
export * from "./NhapKho.vue?vue&type=script&lang=js&"
import style0 from "./NhapKho.vue?vue&type=style&index=0&id=5ff5dce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5dce3",
  null
  
)

export default component.exports